import React    from 'react';

export default function DefaultSection({children}){
    return (<section>
        {children}
    </section>)
}